import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AccountStatusState } from '@client/utils/shared-constants';
import { EMPTY } from 'rxjs';
import { map, skip, switchMap } from 'rxjs/operators';

@Injectable()
export class MonerisService {
	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {}
	getLastElement(arr) {
		if (arr.length === 0) {
			return null; // ou undefined, selon ce que vous préférez
		}
		return arr[arr.length - 1];
	}
	hydrate() {
		return this.auth.user.pipe(
			switchMap(u =>
				u
					? this.db
							.object<AccountStatusState>(`/user/${u.uid}/moneris/vault`)
							.valueChanges()
							.pipe(
								map(x => this.getLastElement(Object.values(x))),
								skip(1)
							)
					: EMPTY
			)
		);
	}
}
